/* ================================================================================ */
/* Boost のカテゴリーフィルターを階層表示に組み替える                                */
/*                                                                                  */
/* カテゴリーの実体は Shopify の product_type で、値は最初から                       */
/* `バッグ>ショルダーバッグ` `ファッション>アウター>ダウンコート` のように            */
/* `>` 区切りの階層文字列になっている（最大3階層・160値）。                          */
/* これがフラットな一覧で出ていて選びにくいので、`>` をパースして                     */
/* 開閉できるツリーに組み替える。                                                    */
/*                                                                                  */
/* Boost の Multi-level tags は tag 型専用で product_type には使えず、               */
/* かつ階層を管理画面で1件ずつ手作業で組む仕様のため（160件は非現実的）、             */
/* テーマ側で行う。                                                                  */
/*                                                                                  */
/* Boost が描画したリスト自体は触らない（React の管理下にある）。                     */
/* CSS で隠したうえで（boost-filter-custom.css）その隣に自前のツリーを描画し、        */
/* 選択は隠したボタンを click() して Boost 本体に処理させる。                        */
/* こうすると URL の組み立て・件数の更新・商品の再取得はすべて Boost の実装が         */
/* そのまま効く。                                                                    */
/*                                                                                  */
/* 対象の見つけ方: フィルターのラベル名や data 属性は環境によって付かないことが       */
/* あるため（PC 用と SP ドロワー用で DOM が二重に描画され、属性の有無も異なる）、     */
/* 「値に `>` を含むリスト型フィルター」という中身の形で判定する。                    */
/* ================================================================================ */

(function () {
  'use strict';

  var OPTION_SELECTOR = '.boost-sd__filter-option';
  var NATIVE_LIST_SELECTOR = '.boost-sd__filter-option-listitem';
  var NATIVE_ITEM_SELECTOR = '.boost-sd__filter-option-item';
  var LABEL_SELECTOR = '.boost-sd__filter-option-item-label';
  var AMOUNT_SELECTOR = '.boost-sd__filter-option-item-amount';

  var SEPARATOR = '>';
  var TREE_CLASS = 'rehello-cat-tree';
  var DONE_ATTR = 'data-rehello-hierarchy';

  /* 再描画のたびに開閉状態が飛ばないよう、開いているパスを保持する */
  var expanded = {};

  /* ------------------------------------------------------------------ */
  /* Boost が描画したリストから値を読む                                   */
  /* ------------------------------------------------------------------ */

  /* `   (63)` → 63。Boost が件数を出していない設定なら null */
  function parseAmount(el) {
    if (!el) return null;
    var digits = el.textContent.replace(/[^\d]/g, '');
    return digits === '' ? null : parseInt(digits, 10);
  }

  function nativeList(option) {
    var lists = option.querySelectorAll(NATIVE_LIST_SELECTOR);
    for (var i = 0; i < lists.length; i++) {
      if (!lists[i].classList.contains(TREE_CLASS)) return lists[i];
    }
    return null;
  }

  function readValues(option) {
    var list = nativeList(option);
    if (!list) return [];

    var out = [];
    var items = list.children;
    for (var i = 0; i < items.length; i++) {
      if (!items[i].matches || !items[i].matches(NATIVE_ITEM_SELECTOR)) continue;
      var label = items[i].querySelector(LABEL_SELECTOR);
      if (!label) continue;
      var value = label.textContent.trim();
      if (!value) continue;
      var button = items[i].querySelector('[role="checkbox"], [role="radio"], button');
      if (!button) continue;
      out.push({
        value: value,
        path: value.split(SEPARATOR),
        count: parseAmount(items[i].querySelector(AMOUNT_SELECTOR)),
        checked: button.getAttribute('aria-checked') === 'true',
        button: button
      });
    }
    return out;
  }

  /* ------------------------------------------------------------------ */
  /* 木を組む                                                            */
  /* ------------------------------------------------------------------ */

  /* `バッグ>ウエストバッグ` の並びを
     { name, key, value, count, checked, button, children[] } の木にする。

     中間ノード（例: `ファッション>アウター`）は値として存在しないことがあるので、
     子をたどる過程で必要になった時点で作る。件数は子の合計を積み上げる
     （product_type は商品に1つなので単純合計で重複しない）。 */
  function buildTree(values) {
    var roots = [];
    var index = {};

    function node(key, name, parent) {
      if (index[key]) return index[key];
      var created = {
        key: key,
        name: name,
        value: null,
        button: null,
        count: 0,
        checked: false,
        children: []
      };
      index[key] = created;
      if (parent) parent.children.push(created);
      else roots.push(created);
      return created;
    }

    for (var i = 0; i < values.length; i++) {
      var v = values[i];
      var parent = null;
      var key = '';
      for (var d = 0; d < v.path.length; d++) {
        key = d === 0 ? v.path[d] : key + SEPARATOR + v.path[d];
        var current = node(key, v.path[d], parent);
        current.count += v.count || 0;
        parent = current;
      }
      /* 末端にだけ実際の値を紐づける（ここだけが選択できる） */
      parent.value = v.value;
      parent.checked = v.checked;
      parent.button = v.button;
    }

    return roots;
  }

  /* ------------------------------------------------------------------ */
  /* 描画                                                                */
  /* ------------------------------------------------------------------ */

  function hasCheckedDescendant(node) {
    if (node.checked) return true;
    for (var i = 0; i < node.children.length; i++) {
      if (hasCheckedDescendant(node.children[i])) return true;
    }
    return false;
  }

  function labelSpan(text, count) {
    var frag = document.createDocumentFragment();
    var label = document.createElement('span');
    label.className = 'boost-sd__filter-option-item-label';
    label.textContent = text;
    frag.appendChild(label);
    if (count !== null && count !== undefined) {
      var amount = document.createElement('span');
      amount.className = 'boost-sd__filter-option-item-amount';
      amount.setAttribute('aria-hidden', 'true');
      amount.textContent = ' (' + count + ')';
      frag.appendChild(amount);
    }
    return frag;
  }

  /* 子を持つノード: 開閉のみ。product_type に中間の値は無いので選択はできない */
  function renderBranch(node, depth) {
    var li = document.createElement('li');
    li.className = 'rehello-cat-node rehello-cat-node--branch rehello-cat-node--depth' + depth;

    var open = !!expanded[node.key] || hasCheckedDescendant(node);
    if (open) expanded[node.key] = true;

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'rehello-cat-toggle';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.appendChild(labelSpan(node.name, node.count));

    var icon = document.createElement('span');
    icon.className = 'rehello-cat-toggle-icon';
    icon.setAttribute('aria-hidden', 'true');
    toggle.appendChild(icon);

    var children = document.createElement('ul');
    children.className = 'rehello-cat-children';
    if (!open) children.hidden = true;
    appendNodes(children, node.children, depth + 1);

    toggle.addEventListener('click', function () {
      var nowOpen = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      children.hidden = !nowOpen;
      expanded[node.key] = nowOpen;
    });

    li.appendChild(toggle);
    li.appendChild(children);
    return li;
  }

  /* 末端ノード: Boost のチェックボックスと同じ見た目。
     クリックは Boost 本体のボタンへ転送する */
  function renderLeaf(node, depth) {
    var li = document.createElement('li');
    li.className =
      'boost-sd__filter-option-item rehello-cat-node rehello-cat-node--leaf rehello-cat-node--depth' +
      depth;

    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('role', 'checkbox');
    button.setAttribute('aria-checked', node.checked ? 'true' : 'false');
    button.className =
      'boost-sd__filter-option-item-button boost-sd__filter-option-item-button--as-button' +
      ' boost-sd__filter-option-item-button--with-checkbox';
    if (node.checked) {
      button.classList.add('boost-sd__filter-option-item-button--selected');
    }
    button.appendChild(labelSpan(node.name, node.count));

    button.addEventListener('click', function () {
      if (node.button) node.button.click();
    });

    li.appendChild(button);
    return li;
  }

  function appendNodes(ul, nodes, depth) {
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      /* 中間ノードが実値も持つ場合（`ファッション>アウター` 単体など）は
         子をたためることを優先する */
      ul.appendChild(node.children.length ? renderBranch(node, depth) : renderLeaf(node, depth));
    }
  }

  function render(option) {
    var values = readValues(option);
    if (!values.length) return;

    /* 階層を持つ値が1つも無いフィルターは Boost のままで十分 */
    var hasHierarchy = false;
    for (var i = 0; i < values.length; i++) {
      if (values[i].path.length > 1) {
        hasHierarchy = true;
        break;
      }
    }
    if (!hasHierarchy) return;

    var list = nativeList(option);
    if (!list) return;

    var tree = document.createElement('ul');
    tree.className = NATIVE_LIST_SELECTOR.slice(1) + ' ' + TREE_CLASS;
    appendNodes(tree, buildTree(values), 1);

    var existing = option.querySelector('.' + TREE_CLASS);
    if (existing) existing.parentNode.replaceChild(tree, existing);
    else list.parentNode.insertBefore(tree, list.nextSibling);

    /* CSS 側で Boost のリストを隠すための目印。
       JS が動かなければ属性が付かず、元のフラットな一覧がそのまま出る */
    option.setAttribute(DONE_ATTR, '1');
  }

  /* ------------------------------------------------------------------ */
  /* Boost の再描画に追従する                                            */
  /* ------------------------------------------------------------------ */

  var pending = null;

  function renderAll() {
    var options = document.querySelectorAll(OPTION_SELECTOR);
    for (var i = 0; i < options.length; i++) render(options[i]);
  }

  function scheduleRender() {
    if (pending) return;
    pending = window.setTimeout(function () {
      pending = null;
      renderAll();
    }, 80);
  }

  function init() {
    scheduleRender();

    if (typeof MutationObserver === 'undefined') return;

    /* Boost はフィルター操作・ページ送りのたびにリストを差し替える。
       自前ツリー内の変化で再帰しないよう、変更元がツリー内なら無視する */
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target && target.nodeType === 1 && target.closest && target.closest('.' + TREE_CLASS)) {
          continue;
        }
        scheduleRender();
        return;
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
